export default __webpack_public_path__ + "static/media/o-600.95264708.woff2";